export const tableItems = {
    headers: [
        {
            value: "Descripción",
        },
        {
            value: "Monto",
        },
        {
            value: "Mét. pago",
        },
        {
            value: "Caja chica",
        },
        {
            value: "Responsable",
        },
        {
            value: "F. registro",
        },
        {
            value: "F. gasto",
        },
        {
            value: "Acciones",
        },
    ],
}

export const tableItemsRecepcion = {
    headers: [
        {
            value: "Descripción",
        },
        {
            value: "Monto",
        },
        {
            value: "Responsable",
        },
        {
            value: "F. registro",
        },
        {
            value: "Acciones",
        },
    ],
}